export default "__VITE_ASSET__047b9ae9__"